import { ContactDetails, ContactDetailsChange } from 'cpfr-common';
import { useAnalyticsActionTracker, useAnalyticsFormTracker } from '@cp-shared-19/frontend-ui';
import { changeContactDetailsPath } from 'components/navigation/paths';
import React, { useState } from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { ConsultView } from './consult-view/ConsultView';
import { EditStatus, EditView } from './edit-view/EditView';
import { isEmpty } from 'lodash';

export type EditStatusWithData = {
    status: EditStatus;
    contactDetails?: ContactDetails;
    formValues?: ContactDetailsChange;
};

export const ContactSection: React.FC<{
    contactDetails?: ContactDetails;
    isContactInformationChangePending: boolean;
}> = ({ contactDetails, isContactInformationChangePending }) => {
    const contactDetailsData = isEmpty(contactDetails)
        ? {
              email: '',
              mobilePhone: '',
              otherPhone: '',
          }
        : contactDetails;

    const { path } = useRouteMatch();
    const history = useHistory();

    const { onAction: onStart } = useAnalyticsActionTracker('onEditProfileContact');
    const { onAction: onCancel } = useAnalyticsActionTracker('onEditProfileCancel');
    const { onError, onSuccess } = useAnalyticsFormTracker({
        confirmError: 'onEditProfileContactSubmitFailed',
        confirmSuccess: 'onEditProfileContactSuccess',
    });

    const [editStatus, setEditStatus] = useState<EditStatusWithData>({
        status: EditStatus.NOT_PERFORMED,
        contactDetails: contactDetailsData,
    });

    const startEditing = (): void => {
        onStart();
        history.push(changeContactDetailsPath());
    };

    const cancelEditing = (): void => {
        onCancel('Contact');
        setEditStatus({
            ...editStatus,
            status: EditStatus.NOT_PERFORMED,
            contactDetails,
        });
        history.push(path);
    };

    const finishEditing = (newEditStatus: EditStatus, updatedContact?: ContactDetails): void => {
        // eslint-disable-next-line
        newEditStatus === EditStatus.SUCCESS ? onSuccess() : onError();
        setEditStatus({
            ...editStatus,
            status: newEditStatus,
            contactDetails: newEditStatus === EditStatus.SUCCESS ? updatedContact : contactDetails,
        });
        history.replace(path);
    };

    return (
        <Switch>
            <Route exact path={changeContactDetailsPath()}>
                <EditView
                    contactDetails={contactDetailsData}
                    cancelEditing={cancelEditing}
                    finishEditing={finishEditing}
                />
            </Route>
            <Route path={path}>
                <ConsultView
                    changePending={isContactInformationChangePending || isContactInformationChangePending}
                    contactDetails={editStatus.contactDetails}
                    startEditing={startEditing}
                    editStatus={editStatus.status}
                />
            </Route>
        </Switch>
    );
};
